import React from 'react';
import * as S from './styled';

export interface Props {
  text: string;
  size?: 'small' | 'large';
  imgSrc?: string;
}

const Avatar = ({ text, imgSrc, size = 'large' }: Props) => (
  <S.AvatarContainer
    $text={text}
    $imgSrc={imgSrc}
    data-testid="avatar-container"
    id="userInitials"
    $size={size}
  >
    {!imgSrc && text}
  </S.AvatarContainer>
);

export default Avatar;
